var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-banner",style:({background: `url(${_vm.bannerContent.src})`,backgroundSize: 'cover',backgroundPosition: 'center'})},[_c('div',{staticClass:"title-warp"},[_c('ElRow',{staticClass:"title-content"},[_c('ElCol',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.bannerContent.title))])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }